import React from "react";

const NoRecordsAvailable = () => {
  return (
    <p className="fs-4 m-5 text-secondary text-center">No records available</p>
  );
};

export default NoRecordsAvailable;
